export default __webpack_public_path__ + "static/media/perfil.29f896ee.svg";